import { useState } from 'react';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20coral%20peach%20and%20golden%20amber%20tones%2C%20soft%20ethereal%20atmosphere%2C%20cinematic%20lighting%20with%20gentle%20lens%20flares%2C%20dreamy%20and%20elegant%20composition%2C%20no%20text%20or%20objects%2C%20pure%20abstract%20art&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="蜜桃在线 Hero 背景"
          className="w-full h-full object-cover"
          title="蜜桃在线-高清视频平台"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white/90 text-sm mb-6">
            <i className="ri-sparkling-2-line text-accent-400"></i>
            <span>每日更新 1000+ 高清资源</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
            发现你的下一部
            <span className="text-accent-400">心头好</span>
          </h1>

          <p className="text-base md:text-lg text-white/75 mb-8 max-w-xl mx-auto leading-relaxed">
            海量高清视频资源一站畅享，电影、电视剧、综艺、动漫、纪录片全收录，流畅播放，多终端同步，随时随地开启娱乐之旅
          </p>

          {/* Search Bar */}
          <form onSubmit={handleSearch} className="max-w-lg mx-auto mb-8">
            <div className="flex items-center bg-white/15 backdrop-blur-md border border-white/25 rounded-xl overflow-hidden hover:border-white/40 transition-colors">
              <div className="pl-5 pr-2 w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line text-white/70 text-lg"></i>
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你喜欢的电影、电视剧、综艺..."
                className="flex-1 px-2 py-3.5 bg-transparent text-white text-sm placeholder:text-white/45 focus:outline-none"
              />
              <button
                type="submit"
                className="px-6 py-3.5 bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                搜索资源
              </button>
            </div>
          </form>

          {/* Stats */}
          <div className="flex items-center justify-center gap-6 md:gap-12 text-white">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">50万+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">视频资源</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">2000万+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading">99.9%</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">服务可用率</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}